export const inspectTable = [
  {
    content: "근로자에 대한 교육 실시 (법 제29조)\n" +
      "- 신규교육(채용시), 정기교육, 작업내용 변경시 및 특별교육\n" +
      "- 교육계획 수립 여부\n" +
      "- 교육평가(안전지식 인지 여부)\n" +
      "- 교육실시 심층조사",
    isChecked: "",
  },
  {
    content: "건설업 기초안전보건교육 실시 (법 제31조)",
    isChecked: "",
  },
  {
    content: "안전보건관계자 직무교육 실시 (법 제32조)\n- 안전보건관리책임자, 안전관리자, 보건관리자, 안전보건관리담당자",
    isChecked: "",
  },
];
